import React, { Fragment, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { Beat } from "../../plugins/spinners.plugin";
import Input from "../inputs/inputs";
import Button from "../buttons/buttons";
//images
import CLOSE from "../../assets/images/icons/close.svg";
//Api
import { isAuthenticatedUser, getUserFromStorage } from "../../utils/Auth";
import { cleanInput } from "../../helpers/cleanInput";
import {
  storePublicCartProducts,
  showMyCart,
  updateCoupon,
  validateCart,
} from "../../redux/cart/cartAction";
// import { validatePublicCart } from "../../redux/publicCart/publicCartAction";
import errorHandler from "../../handlers/errorHandler";
import { getLocalStorageJSON } from '../../helpers/getLocalStorageJSON';

export function AddCouponModal(props) {
  const { myCart, myCarts, currentAddress, currentShipper } = props;
  const dispatch = useDispatch();
  const isAuth = isAuthenticatedUser();
  const user = getUserFromStorage();
  const { updatingCoupon } = useSelector((state) => state.cart);
  const [submitted, setSubmitted] = useState(false);
  const [checkout_codes, setCheckoutCodes] = useState({
    checkout_code_slug: "",
  });
  const { checkout_code_slug } = checkout_codes;

  const handleChange = (e) => {
    const { name, value } = e?.target;
    e.preventDefault();
    setCheckoutCodes({ ...checkout_codes, [name]: value });
  };

  // Function to handle coupon validation errors
  const handleCouponValidationError = (error) => {
    try {
      const errors = error?.response?.data?.errors;
      if (errors && errors.coupons && errors.coupons.length > 0) {
        // Display only the first coupon error
        errorHandler(
          {
            response: {
              data: {
                message: errors.coupons[0],
              },
            },
          },
          true
        );
      } else {
        // If no coupon-specific error, use default error handler
        errorHandler(error, true);
      }
    } catch (err) {
      console.log("Error handling coupon validation:", err);
    }
  };

  const applyCoupon = async () => {
    const localCart = getLocalStorageJSON("ogwugo-cart");
    setSubmitted(true);
    if (isAuth) {
      if (checkout_code_slug) {
        setSubmitted(false);
        try {
          const response = await dispatch(
            updateCoupon({
              user_id: user?.id,
              checkout_codes: [checkout_codes],
            })
          );
          if (response?.status_code === 200) {
            dispatch(showMyCart());

            //validate the cart before opening the payment modal
            const payload = {
              address_id: currentAddress?.id || "",
              shipper_id: currentShipper?.id || "",
              delivery_mode_id: currentShipper?.delivery_mode_id || "",
            };
            cleanInput(payload);

            if (currentAddress?.id && currentShipper?.id) {
              await dispatch(validateCart(payload));
            }
          }
        } catch (error) {
          console.log("error", error);
          handleCouponValidationError(error);
        }
      }
    } else {
      if (localCart) {
        let updateCart = localCart;
        //if there are items in the local cart
        if (checkout_code_slug) {
          updateCart.checkout_codes = [checkout_codes];
        }
        try {
          cleanInput(updateCart);
          const response = await dispatch(storePublicCartProducts(updateCart));
          if (response) {
            //validate the cart
            // const payload = {
            //   shipper_id: currentShipper?.id || "",
            //   delivery_mode_id: currentShipper?.delivery_mode_id || "",
            // };
            // cleanInput(payload);

            // if (currentShipper?.id) {
            //   await dispatch(validatePublicCart(payload));
            // }

            localStorage.setItem(
              "ogwugo-cart-items",
              JSON.stringify(response?.data)
            );
            localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
            window.dispatchEvent(new Event("localStorageUpdated"));
          }
        } catch (error) {
          console.log("error", error);
          handleCouponValidationError(error);
        }
      } else {
        //store the public cart
        let updateCart = {
          checkout_codes: [checkout_codes],
          shipper_id: currentShipper?.id || "",
          delivery_mode_id: currentShipper?.delivery_mode_id || "",
        };
        try {
          cleanInput(updateCart);
          if (currentShipper?.id) {
            const response = await dispatch(
              storePublicCartProducts(updateCart)
            );

            if (response) {
              localStorage.setItem(
                "ogwugo-cart-items",
                JSON.stringify(response?.data)
              );
              localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
              window.dispatchEvent(new Event("localStorageUpdated"));
            }
          }
        } catch (error) {
          console.log("error", error);
          handleCouponValidationError(error);
        }
      }
    }
  };

  const removeCoupon = async () => {
    // const localCart = JSON.parse(localStorage.getItem("ogwugo-cart"));
    const localCart = getLocalStorageJSON("ogwugo-cart");
    if (isAuth) {
      if (
        myCarts?.coupons?.length > 0 ||
        myCarts?.promotion_codes?.length > 0
      ) {
        try {
          const response = await dispatch(
            updateCoupon({
              user_id: user?.id,
              checkout_codes: null,
              coupons: null,
              promotion_codes: null,
            })
          );
          if (response?.status_code === 200) {
            dispatch(showMyCart());
            setCheckoutCodes({ checkout_code_slug: "" });
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    } else {
      if (localCart) {
        let updateCart = localCart;
        updateCart.checkout_codes = null;
        updateCart.coupons = null;
        updateCart.promotion_codes = null;
        //if there are items in the local cart
        try {
          cleanInput(updateCart);
          const response = await dispatch(storePublicCartProducts(updateCart));
          if (response) {
            localStorage.setItem(
              "ogwugo-cart-items",
              JSON.stringify(response?.data)
            );
            localStorage.setItem("ogwugo-cart", JSON.stringify(updateCart));
            window.dispatchEvent(new Event("localStorageUpdated"));
            setCheckoutCodes({ checkout_code_slug: "" });
          }
        } catch (error) {
          console.log("error", error);
        }
      }
    }
  };

  return (
    <div data-test="addressModal">
      <Transition show={props.show} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={props.onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative w-[650px] bg-white dark:bg-[#121212] rounded-3xl px-4 pt-5 pb-4 max-h-[90vh] h-full overflow-scroll shadow-xl transform transition-all sm:my-10 sm:max-w-lg sm:w-full  sm:p-8">
                  <div className="sm:block absolute top-1 sm:top-3 right-4 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-[#ffeae5] rounded-3xl p-2 sm:p-3 outline-none"
                      onClick={props.onClose}
                    >
                      <span className="sr-only">Close</span>
                      <img
                        src={CLOSE}
                        alt="close"
                        className=" w-3 h-3 sm:w-4 sm:h-4"
                      />
                    </button>
                  </div>
                  <div className="sm:flex">
                    <div className="text-left sm:mt-2">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium text-black dark:text-white"
                      >
                        Coupon
                      </Dialog.Title>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4">
                    <div className="mt-4 border-b-2 "></div>
                    <div className="mt-8">
                      <div>
                        {/* <h3 className="text-xl font-medium mb-2">
                          Add a coupon (optional)
                        </h3>
                        <p className="mb-4">
                          If you have a coupon code, please apply it below.
                        </p> */}
                        {myCart?.coupons?.length > 0 ||
                        myCart?.promotion_codes?.length > 0 ? (
                          <div className="">
                            <Input.Label
                              title={"Coupon Code"}
                              type={"text"}
                              name={"checkout_codes"}
                              placeholder={`Enter a coupon code to enjoy discounts`}
                              onChange={handleChange}
                              value={
                                myCart?.coupons?.[0]?.coupon_slug ||
                                myCart?.promotion_codes?.[0]
                                  ?.promotion_code_slug
                              }
                              disabled
                              className="mt-2 mb-12 flex-1 h-12 pl-3 pr-10 w-full rounded-lg text-lg text-[#676565] bg-[#C4C4C4] dark:bg-transparent focus:outline-none sm:text-sm px-4 py-2 mb-4 border border-[#DADADA] "
                            />

                            <Button.Secondary
                              type="button"
                              disabled={updatingCoupon}
                              className="w-full h-12 rounded-lg"
                              title={
                                updatingCoupon ? (
                                  <Beat color={"#CE2600"} />
                                ) : (
                                  "Remove Coupon"
                                )
                              }
                              onClick={() => {
                                removeCoupon();
                              }}
                            />
                          </div>
                        ) : (
                          <div className="">
                            <Input.Label
                              title={"Coupon Code"}
                              type={"text"}
                              name={"checkout_code_slug"}
                              placeholder={`Enter a coupon code to enjoy discounts`}
                              onChange={handleChange}
                              value={checkout_code_slug}
                              className={"mb-12"}
                            />
                            {submitted && checkout_codes?.length < 1 && (
                              <p className="text-primary text-sm">
                                You have not entered any coupon code!
                              </p>
                            )}

                            <Button.Primary
                              type="button"
                              disabled={updatingCoupon}
                              className="bg-primary text-white w-full h-12 rounded-lg"
                              title={updatingCoupon ? <Beat /> : "Apply Coupon"}
                              onClick={() => {
                                applyCoupon();
                              }}
                            />
                          </div>
                        )}
                      </div>

                      <Button.Secondary
                        type="button"
                        className=" w-full h-12 rounded-lg mt-5"
                        title={"Cancel"}
                        onClick={props.onClose}
                      />
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
